export default __webpack_public_path__ + "047ce9165c016981c1bb65362d7be82e.png";